"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = exports.RouterLink = exports.TitleLink = exports.Title = exports.Column = exports.Card = void 0;
const Link_1 = __importDefault(require("@mui/material/Link"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const Box_1 = __importDefault(require("@mui/material/Box"));
exports.Card = (0, material_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(1.8),
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
}));
exports.Column = (0, material_1.styled)("div") `
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px ${({ theme }) => theme.spacing(1.8)}px;
`;
exports.Title = (0, material_1.styled)("button")(() => ({
    letterSpacing: 0.44,
    lineHeight: 1.75,
    color: "#000",
    border: "none",
    cursor: "pointer",
    backgroundColor: "#0000",
}));
exports.TitleLink = (0, material_1.styled)(Link_1.default) `
  cursor: pointer;
  color: ${({ theme }) => theme.palette.common.black};
  margin-bottom: ${({ theme }) => theme.spacing(1)}px;
`;
exports.TitleLink.defaultProps = { underline: "hover" };
exports.RouterLink = (0, material_1.styled)(react_router_dom_1.Link) `
  color: ${({ theme }) => theme.palette.common.black};
  margin-bottom: ${({ theme }) => theme.spacing(1.8)}px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
exports.Loader = (0, material_1.styled)(Box_1.default)(() => ({
    width: 60,
    height: 45,
    justifyContent: "center",
}));
